// Compact presentation of existing public catalogue copy, not a second catalogue.
// Prefer the admin's existing Subtitle field; retain the full Description in Details.
export function compactPackSummary(pack = {}) {
    const clean = v => typeof v === 'string' ? v.replace(/\s+/g, ' ').trim() : '';
    const source = clean(pack.subLabel) || clean(pack.description);
    if (!source) return 'Explore the published contents and available sample for this pack.';
    const first = source.match(/^.*?[.!?](?=\s|$)/)?.[0] || source;
    if (first.length <= 190) return first;
    const prefix = first.slice(0, 187);
    const boundary = prefix.lastIndexOf(' ');
    return prefix.slice(0, boundary > 100 ? boundary : prefix.length).trimEnd() + '…';
}

export function packCardOffer(pack = {}, packs = [], signedIn = false) {
    const free = Number(pack.freeItems) > 0;
    const members = Array.isArray(pack.memberPackIds) ? pack.memberPackIds : [];
    return {
        summary: compactPackSummary(pack),
        price: Number.isFinite(pack.price) && pack.price > 0 ? 'HK$' + pack.price.toLocaleString('en-HK', { maximumFractionDigits: 2 }) : null,
        href: signedIn ? '/dashboard' : free ? '/preview/' + pack.id : '/login?mode=signup',
        action: signedIn ? 'Open library' : free ? 'Preview free lesson' : 'Create an account',
        free,
        // Never invent a member name or expose a pack outside the public catalogue.
        memberNames: [...new Set(members)].map(id => packs.find(p => p.id === id)?.label).filter(Boolean),
        bundle: members.length > 0,
    };
}
